import type { TrainingTotals } from '@train2volley/shared';

const time = new Intl.DateTimeFormat('nl-NL', { hour: '2-digit', minute: '2-digit' });
const day = new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
const dayLong = new Intl.DateTimeFormat('nl-NL', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatTime = (d: Date) => time.format(d);
/** "di 20 okt · 19:30" */
export const formatWhen = (iso: string) =>
  `${day.format(new Date(iso))} · ${time.format(new Date(iso))}`;
export const formatWhenLong = (iso: string) => dayLong.format(new Date(iso));

/** "45 min" of "45 min + 1 zonder duur": onbekend telt nooit als 0 (docs/03). */
export function totalsLabel(t: TrainingTotals) {
  const base = `${t.knownMinutes} min`;
  if (t.unknownCount === 0) return base;
  return `${base} + ${t.unknownCount} zonder duur`;
}

/**
 * Start- en eindtijd per regel vanaf `scheduledAt`. Na de eerste regel zonder
 * duur zijn de tijden onbekend: we verzinnen niets.
 */
export function timeSlots(scheduledAt: string | null, durations: (number | null)[]) {
  if (!scheduledAt) return durations.map(() => null);
  let cursor: number | null = new Date(scheduledAt).getTime();
  return durations.map((d) => {
    if (cursor === null || d === null) {
      cursor = null;
      return null;
    }
    const start = new Date(cursor);
    cursor += d * 60_000;
    return { start, end: new Date(cursor) };
  });
}

/** `datetime-local` (lokale tijd) ↔ ISO met offset voor de API. */
export function toLocalInput(iso: string | null) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
